export const defaultProductionApiUrl = 'https://events-api.aiescapelabs.com';
export const defaultDevelopmentApiUrl = 'http://localhost:80';

function trimTrailingSlash(url: string) {
  return url.trim().replace(/\/+$/, '');
}

function runtimeApiUrl() {
  return window.ESCAPE_EVENTS_CONFIG?.apiUrl;
}

export function resolveApiUrl(
  nodeEnv = process.env.NODE_ENV,
  buildApiUrl = process.env.REACT_APP_ESCAPE_EVENTS_API_URL,
  runtimeConfiguredApiUrl = runtimeApiUrl(),
) {
  const configuredUrl = runtimeConfiguredApiUrl || buildApiUrl;
  if (configuredUrl?.trim()) {
    return trimTrailingSlash(configuredUrl);
  }

  return !nodeEnv || nodeEnv === 'development'
    ? defaultDevelopmentApiUrl
    : defaultProductionApiUrl;
}
